export default {
  id: 85,
  title: 'Target #85 - Pythagoras',
  url: 'https://cssbattle.dev/play/85',
  colors: ['#D25B70', '#F7F3DA', '#F6DF96', '#6CB3A9'],
  solution:
    '<a a><a b><a c><style>[a],[b]{left:150}[b],[c]{bottom:150;transform-origin:bottom left}body{background:#d25b70}a{position:fixed}[a]{width:100;height:100;top:150;background:#f7f3da}[b]{width:60;height:60;background:#6cb3a9;transform:rotate(-53deg)}[c]{width:80;height:80;left:250;background:#f6df96;transform:rotate(-53deg)}</style>',
}
